import WalletConnectProvider from '@walletconnect/web3-provider';
import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
import Fortmatic from 'fortmatic';
import Torus from '@toruslabs/torus-embed';

export const createProviderOptions = (chainId) => ({
    walletconnect: {
        package: WalletConnectProvider, // required
        options: {
            infuraId: process.env.REACT_APP_INFURA_ID, // required
        },
    },

    coinbasewallet: {
        package: CoinbaseWalletSDK, // Required
        options: {
            appName: 'Payonix', // Required
            infuraId: process.env.REACT_APP_INFURA_ID, // Required
            chainId: chainId, // Optional. It defaults to 1 if not provided
        },
    },

    fortmatic: {
        package: Fortmatic, // required
        options: {
            key: process.env.REACT_APP_FORTMATIC_KEY, // required
        },
    },

    torus: {
        package: Torus, // required
        options: {
            networkParams: {
                chainId: chainId,
                networkId: chainId,
            },
        },
    },

    binancechainwallet: {
        package: true,
    },
});
